<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'线索管理'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
          <div class="h-piece">
            <div class="h-formBox">
              <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="大区" prop="areaName">
                    <brselect category="daqu" :v="q.daqu" v-model="q.daqu"
                              :clearable="true"
                              style="width:100%"/>
                  </el-form-item>
                  <el-form-item label="区域" prop="areaName">
                    <brselect category="show_area" :v="q.areaName" v-model="q.areaName"
                                  :clearable="true"
                                  style="width:100%"/>
                  </el-form-item>
                  <el-form-item label="销售人员">
                    <el-input v-model="q.salesManName" placeholder="请输入名称/编码" :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="用户单位">
                    <el-input v-model="q.userUnitName" placeholder="请输入名称" :clearable="true"></el-input>
                  </el-form-item>
                </div>
                <el-collapse-transition>
                <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="渠道名称" prop="channelName">
                    <brselect category="clue_channel" :v="q.channelName" v-model="q.channelName"
                                  :clearable="true"
                                  style="width:100%"/>
                  </el-form-item>
                  <el-form-item label="线索来源" prop="clueFrom">
                    <el-select v-model="q.clueFrom"
                               placeholder="线索来源" style="width: 100%;" :clearable="true" >
                      <el-option
                              v-for="item in cluesList"
                              :key="item.clueResourceType"
                              :label="item.clueResourceName"
                              :value="item.clueResourceType">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="创建日期" class="timeselect" style="width: 50%;">
                    <el-date-picker
                        placeholder="请选择"
                        v-model="q.startDate"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd" >
                    </el-date-picker>
                    <span class="w-time-to">至</span>
                    <el-date-picker
                        placeholder="请选择"
                        v-model="q.endDate"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd" >
                    </el-date-picker>
                  </el-form-item>

                </div>
                    <div class="h-thirdColumn w-newColumn">
                      <el-form-item label="线索状态" prop="trackStatus">
                        <brselectlazy category="track_status_zb" :v="q.trackStatus" v-model="q.trackStatus"
                                      :clearable="true"
                                      style="width:100%"/>
                      </el-form-item>
                      <el-form-item label="处理状态" prop="state">
                        <el-select v-model="q.state" :clearable="true">
                          <el-option label="待办" value="0">待办</el-option>
                          <el-option label="已办" value="1">已办</el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="来电电话">
                        <el-input v-model="q.incomingCall" placeholder="请输入" :clearable="true"></el-input>
                      </el-form-item>
                      <el-form-item label="联系方式">
                        <el-input v-model="q.telephone" placeholder="请输入" :clearable="true"></el-input>
                      </el-form-item>
                    </div>
                  <div class="h-thirdColumn w-newColumn">
                    <el-form-item label="漏斗编号">
                      <el-input v-model="q.funnelCode" placeholder="请输入" :clearable="true"></el-input>
                    </el-form-item>
                    <el-form-item label="录入人">
                      <el-input v-model="q.cusername" placeholder="请输入" :clearable="true"></el-input>
                    </el-form-item>
                  </div>
                </div>
                </el-collapse-transition>
              </el-form>
              <div class="l-screenBox">
                <div class="l-screen" @click="collapseChange">
                  <img :src="isScreen?closeScreen:drawScreen" alt="">
                  <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                </div>
                <div class="l-retrieval">
<!--
                  <el-button class="h-btn h-formBtn h-bggreen" @click="designate">指派</el-button>
-->
                  <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                  <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                  <el-button  v-if="!dlsflag" class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                    新增
                  </el-button>
                </div>
              </div>
            </div>
          </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :border="true"
                    max-height="560"
                    style="width: 100%"
                >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                  <el-table-column
                    label="序号"
                     type="index"
                     width="50px">
                  </el-table-column>
                  <el-table-column prop="daqu"  label="大区" width="60px" ></el-table-column>
                  <el-table-column prop="areaName"  label="区域" width="60px" ></el-table-column>
                  <el-table-column prop="province"  label="省" width="100px" ></el-table-column>
                  <el-table-column prop="city"  label="市" width="80px" ></el-table-column>
                  <el-table-column prop="salesManName" label="销售人员" width="80px" ></el-table-column>
                  <el-table-column prop="field" label="领域" width="80px">
                    <template slot-scope="scope">
              <span v-if="scope.row.field == 1 ">
                                医疗
                              </span>
                      <span v-if="scope.row.field == 2 ">
                                制药
                              </span>
                      <span v-if="scope.row.field == 3 ">
                                高科
                              </span>
                      <span v-if="scope.row.field == 4 ">
                                疫苗
                              </span>
                      <span v-if="scope.row.field == 5 ">
                                血液
                              </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="channelName" label="渠道名称" width="100px" ></el-table-column>
                  <el-table-column prop="clueFromName" label="线索来源" width="100px" ></el-table-column>
                    <el-table-column prop="emergency" label="是否紧急" width="80px" >
                        <template scope="scope">
                            <span style="color: red;" v-if="scope.row.emergency == 1">是</span>
                            <span v-if="scope.row.emergency == 0">否</span>
                        </template>
                    </el-table-column>


                  <el-table-column prop="userUnitName" label="用户单位" width="180px"></el-table-column>
                  <el-table-column prop="leader" label="负责人" width="80px" ></el-table-column>
                  <el-table-column prop="incomingCall" label="来电电话" width="120px" ></el-table-column>
                  <el-table-column prop="telephone" label="联系方式" width="120px" ></el-table-column>

                    <el-table-column prop="userRequire" label="用户需求">
                        <template slot-scope="scope">
                            <el-link v-if="isUrl(scope.row.userRequire)" :href="scope.row.userRequire" target="_blank" type="primary">
                                {{scope.row.userRequire}}
                            </el-link>
                            <span v-else>{{scope.row.userRequire}}</span>
                        </template>
                    </el-table-column>



                  <el-table-column prop="funnelCode" label="漏斗编号" width="130px" >
                    <template scope="scope">
                      <a v-if="scope.row.fromSource!='MC_03_400'" @click="employeesdetails(scope.row.funnelCode)" style="color: #29affb; cursor: pointer"  >{{ scope.row.funnelCode}}</a>
                      <a v-if="scope.row.fromSource=='MC_03_400' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)" @click="updateDetailxs(scope.row.clueid)" style="color: #29affb; cursor: pointer"  >{{ scope.row.funnelCode}}</a>
                      <span v-if="scope.row.fromSource=='MC_03_400' && !(_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)">{{ scope.row.funnelCode}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="funnelMoney" label="漏斗金额（元）" width="120px" ></el-table-column>
                   <el-table-column prop="estimatedAmount" label="预估金额" width="120px" ></el-table-column>

                  <el-table-column prop="state" label="线索状态" width="100px" >
                    <template slot-scope="scope">
                      <dictname  v-if="scope.row.fromSource"  category="track_status_zb" :v="scope.row.trackStatus"></dictname>
                      <dictname  v-else  category="track_status" :v="scope.row.trackStatus"></dictname>
                    </template>

                  </el-table-column>
                  <el-table-column prop="state" label="处理状态" width="80px" >
                    <template scope="scope">
                      <span v-if="scope.row.state == 1">已办</span>
                      <span v-if="scope.row.state == 0">待办</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="pnum" label="催办次数" width="80px" ></el-table-column>
                  <el-table-column prop="cusername" label="录入人" width="70px" ></el-table-column>
                  <el-table-column prop="cdate" label="创建时间" width="150px" ></el-table-column>
                  <el-table-column prop="bscPrice" label="关联订单总额" width="150px" ></el-table-column>
                  <el-table-column prop="bscSellordeid" label="关联订单号" width="340px" ></el-table-column>
                  <el-table-column prop="memo" label="备注" width="100px" ></el-table-column>
                  <el-table-column
                      label="操作"
                      fixed="right"
                      width="340"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.id" style="text-align: left;">
                      <el-button
                            v-if="scope.row.funnelCode == '' || scope.row.funnelCode == null "
                            type="text"
                            size="small"
                            class="h-tableLink h-btn"
                            @click="updateDetail(scope.row)"
                        >查看</el-button>
                          <!--       <el-button
                                   v-if="scope.row.funnelCode == '' || scope.row.funnelCode == null "
                                   type="text"
                                   size="small"
                                   style="padding: 0;"
                                   class="h-tableLink h-btn"
                                   @click="deleteSingle(scope.row.id)">
                                 删除
                               </el-button>
                            <el-button
                                   type="text"
                                   size="small"
                                   style="padding: 0;"
                                   class="h-tableLink h-btn"
                                   @click="saveClue(scope.row)">
                                 线索跟踪
                               </el-button>
                               <el-button
                                   type="text"
                                   size="small"
                                   style="padding: 0;"
                                   class="h-tableLink h-btn"
                                   @click="selectcluedetails(scope.row)">
                                 跟踪详情
                               </el-button>-->
                          <el-button
                              v-if=" _user.usercode ==  scope.row.salesManCode && scope.row.state == 0 && (scope.row.taskType == 4 || scope.row.taskType == 5 ) "
                              type="text"
                              size="small"
                              class="h-tableLink h-btn"
                              @click="designate(scope.row)"
                          >确认指派
                          </el-button>

                          <el-button
                              v-if="(scope.row.trackStatus == '' || scope.row.trackStatus == null) && _user.usercode ==  scope.row.salesManCode && (scope.row.taskType != 4 && scope.row.taskType != 5  && scope.row.taskType!=9)"
                              type="text"
                              size="small"
                              class="h-tableLink h-btn"
                              @click="undertakeOpen(scope.row)"
                          >承接
                          </el-button>

                          <!-- 销售人员为当前登录人，并且没有承接的 且不等于员工待指派  -->
                          <el-button
                              type="text"
                              size="small"
                              class="h-tableLink h-btn"
                              @click="selectcluedetails(scope.row)">
                              跟踪日志
                          </el-button>

                          <el-button
                              v-if="scope.row.trackStatus == '1' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)"
                              type="text"
                              size="small"
                              class="h-tableLink h-btn"
                              @click="toProject(scope.row)">
                              转项目
                          </el-button>
                          <el-button
                              v-if="scope.row.trackStatus == '4' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)"
                              type="text"
                              size="small"
                              class="h-tableLink h-btn"
                              @click="updateDetailxs(scope.row.loudId)">
                              漏斗
                          </el-button>


<!--                        <el-button
                            v-if="!dlsflag"
                            type="text"
                            size="small"
                            class="h-tableLink h-btn"
                            @click="savePress(scope.row)"
                        >催办</el-button>-->
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
        </div>

      <!-- 新增弹出层 -->
      <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add"  ref="addForm" label-position="right" :inline="true" label-width="80" :rules="editFormRules"
                     class="demo-ruleForm h-formbLine h-formbLine1">
              <el-form-item label="战区" prop="areaCode">
                <brselect category="show_area" v-model="add.areaCode" :v="add.areaCode" :clearable="true"
                :disabled="this.disabled" @change="matchsalesman($event, 'addclue')"></brselect>
              </el-form-item>
              <el-form-item label="省" prop="province">
                <el-select v-model="add.province" filterable clearable @change="handleItemChange1($event)" placeholder="省" style="width: 80%;">
                  <el-option
                      v-for="item in shenglist"
                      :key="item.value"
                      :label="item.name"
                      :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="市" prop="city">
                <el-select v-model="this.add.city" filterable clearable @change="handleItemChange2($event)"
                           :rules="[{ required: true, message: '请输入市', trigger: 'change'},]"
                           placeholder="市" style="width: 100%;">
                  <el-option
                      v-for="item in cityList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="渠道" prop="channelCode">
                <brselect category="clue_channel_zb" v-model="add.channelCode" :v="add.channelCode" :clearable="true"
                   :disabled="this.disabled"></brselect>
              </el-form-item>


<!--
              <el-form-item label="销售人员" prop="salesManName">
                <el-select v-model="this.add.salesManName" filterable clearable @change="salesmanChange($event, 'addclue')"
                @keyup.native="showInfo" placeholder="销售人员" style="width: 100%;" :clearable="true" >
                  <el-option
                      v-for="item in salesmanList"
                      :key="item.id"
                      :label="`${item.userName}(${item.userCode})`"
                      :value="item.userCode">
                  </el-option>
                </el-select>
              </el-form-item>
-->


              <el-form-item label="线索来源" prop="clueFrom">
                <el-select v-model="add.clueFrom"
                           placeholder="线索来源" style="width: 100%;" :clearable="true" >
                  <el-option
                          v-for="item in cluesList"
                          :key="item.clueResourceType"
                          :label="item.clueResourceName"
                          :value="item.clueResourceType">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="用户单位" prop="customerName">
                <el-select v-model="add.userUnitName" remote filterable :filter-method="showGroupClueList" :clearable="true"
                           style="width: 134px;"
                           placeholder="请输入"
                           :remote-method="showGroupClueList" @change="showGroupClueList" :disabled="this.disabled" >
                  <el-option v-for="(item,index) in customerNameList"
                             :key="index"
                             :label="item.deptName"
                             :value="item.deptName">
                  </el-option>
                </el-select>
                <i class="el-icon-circle-plus" @click="createAddress"></i>
              </el-form-item>

              <el-form-item  label="负责人" prop='leader'>
                <el-input v-model="add.leader" :disabled="this.disabled"  placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="来电电话" prop='incomingCall'>
                <el-input v-model="add.incomingCall" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="联系方式" prop='telephone'>
                <el-input v-model="add.telephone" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="用户需求" prop='userRequire'>
                <el-input v-model="add.userRequire" :disabled="this.disabled"  placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="备注" prop='memo'>
                <el-input v-model="add.memo" :disabled="this.disabled"  placeholder="请输入">
                </el-input>
              </el-form-item>

                <el-form-item  prop='emergency' label="是否紧急" >
                    <el-switch style="margin-left: 50px;margin-bottom: 0.2rem"  active-value="1"
                               inactive-value="0" v-model="add.emergency" active-text="紧急" >
                    </el-switch>
                </el-form-item>

            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 修改弹出层 -->
      <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="editDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" label-position="right" :inline="true" label-width="80" :rules="editFormRules"
                     class="demo-ruleForm h-formbLine h-formbLine1">

              <el-form-item label="战区" prop="areaCode">
                <brselect category="show_area" v-model="add.areaCode" :v="add.areaCode" :clearable="true"
                :disabled="this.disabled" @change="matchsalesman($event, 'editclue')"></brselect>
              </el-form-item>
              <el-form-item label="省" prop="province">
                <el-select v-model="add.province" @change="handleItemChange1($event)"
                           placeholder="省" style="width: 68%;" :clearable="true">
                  <el-option
                      v-for="item in shenglist"
                      :key="item.value"
                      :label="item.name"
                      :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="市" prop="city">
                <el-select v-model="this.add.city" @change="handleItemChange2($event)"
                           :rules="[{ required: true, message: '请输入市', trigger: 'change'},]"
                           placeholder="市" style="width: 100%;" :clearable="true">
                  <el-option
                      v-for="item in cityList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="渠道" prop="channelCode">
                <brselect category="clue_channel_zb" v-model="add.channelCode" :v="add.channelCode" :clearable="true"
                 :disabled="this.disabled"></brselect>
              </el-form-item>

<!--              <el-form-item label="销售人员" prop="salesManName">
                <el-select v-model="this.add.salesManName" filterable clearable @change="salesmanChange($event, 'editclue')"
                @keyup.native="showInfo" placeholder="销售人员" style="width: 100%;" :clearable="true">
                  <el-option
                      v-for="item in salesmanList"
                      :key="item.id"
                      :label="`${item.userName}(${item.userCode})`"
                      :value="item.userCode">
                  </el-option>
                </el-select>
              </el-form-item>-->

              <el-form-item label="线索来源" prop="clueFrom">
                <el-select v-model="add.clueFrom"
                           placeholder="销售人员" style="width: 100%;" :clearable="true" >
                  <el-option
                          v-for="item in cluesList"
                          :key="item.clueResourceType"
                          :label="item.clueResourceName"
                          :value="item.clueResourceType">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="用户单位" prop="customerName">
                <el-select v-model="add.userUnitName" remote filterable :filter-method="showGroupClueList" :clearable="true"
                           style="width: 134px;"
                           placeholder="请输入"
                           :remote-method="showGroupClueList" @change="showGroupClueList" :disabled="this.disabled" >
                  <el-option v-for="(item,index) in customerNameList"
                             :key="index"
                             :label="item.deptName"
                             :value="item.deptName">
                  </el-option>
                </el-select>
                <i class="el-icon-circle-plus" @click="createAddress"></i>
              </el-form-item>

              <!--<el-form-item  label="部门/科室" prop='dept'>-->
              <!--  <el-input v-model="add.dept" :disabled="this.disabled"  placeholder="请输入">-->
              <!--  </el-input>-->
              <!--</el-form-item>-->

              <el-form-item  label="负责人" prop='leader'>
                <el-input v-model="add.leader" :disabled="this.disabled"  placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="来电电话" prop='incomingCall'>
                <el-input v-model="add.incomingCall" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="联系方式" prop='telephone'>
                <el-input v-model="add.telephone" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="用户需求" prop='userRequire'>
                <el-input v-model="add.userRequire" :disabled="this.disabled"  placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="备注" prop='memo'>
                <el-input v-model="add.memo" :disabled="this.disabled"  placeholder="请输入">
                </el-input>
              </el-form-item>

            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
<!--            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>-->
          </div>
        </div>
      </el-dialog>

      <!--线索追踪弹出框-->
      <el-dialog :close-on-click-modal="false"  @close='closeCluetrack' :visible.sync="cluetrackDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="BscClueTrack" ref="BscClueTrack" label-position="right" :inline="true" label-width="80" :rules="editFormRules"
                     class="demo-ruleForm h-formbLine h-formbLine1">
              <el-form-item label="跟踪日期" prop="trackDate">
                <el-date-picker
                    v-model="BscClueTrack.trackDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="线索状态" prop="trackStatus">
                <brselect category="track_status_zb" v-model="BscClueTrack.trackStatus" :v="BscClueTrack.trackStatus" :clearable="true"
                          ></brselect>
              </el-form-item>

              <el-form-item  label="跟踪内容" prop="trackContent">
                <el-input v-model="BscClueTrack.trackContent" placeholder="请输入" clearable></el-input>
              </el-form-item>

              <el-form-item label="场景" prop='scenesType' v-if="(this.loudid == '' || this.loudid == null) && (this.BscClueTrack.trackStatus == 1 || this.BscClueTrack.trackStatus == 2)">
                <brselect category="crm_changjing_type" v-model="BscClueTrack.scenesType" :v="BscClueTrack.scenesType" :clearable="true"
                          :disabled="this.disabled"/>
              </el-form-item>

              <div v-if="(this.loudid == '' || this.loudid == null) && (this.BscClueTrack.trackStatus == 1 || this.BscClueTrack.trackStatus == 2)" >
                <el-button @click="addtrackProduct()" type="text" size="mini"
                           style="float:right;font-size:20px;margin-right: -5px" icon="el-icon-circle-plus"
                           circle></el-button>
                <div v-for="(listIt, index) in BscClueTrack.products" :key="index" class="h-formBox">
                  <el-button @click="deletetrackProduct(index)" v-show="index != 0" type="text"
                             style="float:right;font-size:20px;margin-right: -5px;color:#dc143c;" size="mini"
                             icon="el-icon-remove" circle></el-button>
                  <el-form-item label="链群" prop='lianqun' style="margin-left: -15px; margin-right: -15px">
                    <brselect category="xsyb_lianqun" v-model="BscClueTrack.products[index].lianqun"
                              @change="changetrackLianqun($event,index)"
                              :v="BscClueTrack.products[index].lianqun" :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="产品型号">
                    <el-select v-model="BscClueTrack.products[index].proModel" :title="BscClueTrack.products[index].proModel" remote
                               filterable :filter-method="showProductByNameList"  placeholder="请输入"
                               :remote-method="showProductByNameList" @change="changetrackProducts($event,index)">
                      <el-option v-for="(item,index) in productByNameList"
                                 :key="index"
                                 :label="item.proModel"
                                 :value="item.proModel">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="金额" style="margin-left: -15px; margin-right: -15px" >
                    <el-input v-model="BscClueTrack.products[index].price"  remote   oninput="value=value.replace(/[^\d.]/g,'')">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="数量" prop="grabBill">
                    <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="BscClueTrack.products[index].num"></el-input>
                  </el-form-item>
                </div>
              </div>


              <el-form-item  label="客户类型" prop='euType'>
                <el-select v-model="BscClueTrack.euType" placeholder="请选择" @change="changeEuType">
                  <el-option label="用户" value="1"></el-option>
                  <el-option label="经销商" value="2"></el-option>
                  <el-option label="竞品" value="3"></el-option>
                  <el-option label="其他" value="4"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="法人" prop="legalPerson" v-if="euTypeFlag">
                <el-input v-model.trim="BscClueTrack.legalPerson" placeholder="请输入"/>
              </el-form-item>
              <el-form-item label="邮箱" prop="email" v-if="euTypeFlag">
                <el-input v-model.trim="BscClueTrack.email" placeholder="请输入"/>
              </el-form-item>
              <el-form-item label="用户" prop="user" v-if="euTypeFlag">
                <el-input v-model.trim="BscClueTrack.user" placeholder="请输入"/>
              </el-form-item>
              <el-form-item label="建议签约类型" prop="signingType" v-if="euTypeFlag">
                <el-select v-model="BscClueTrack.signingType" :clearable="true"
                           placeholder="请选择">
                  <el-option label="一级经销商" value="一级经销商"></el-option>
                  <el-option label="专营商" value="专营商"></el-option>
                  <el-option label="分销商" value="分销商"></el-option>
                  <el-option label="合伙人" value="合伙人"></el-option>
                  <el-option label="地市直营商" value="地市直营商"></el-option>
                </el-select>
              </el-form-item>


            </el-form>

          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="closeCluetrack">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCluetrack()">提交</el-button>
            <el-button v-if="(this.loudid == '' || this.loudid == null) && (this.BscClueTrack.trackStatus == 1 || this.BscClueTrack.trackStatus == 2)" class="h-btn h-bBtn h-bggreen" @click="createNew()">转换信息漏斗</el-button>
          </div>
        </div>

      </el-dialog>

      <!--追踪详情弹出框-->
<!--      <el-dialog :close-on-click-modal="false"  @close='closeCluedetails' :visible.sync="cluedetailsDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div style="padding-top: 12px;">
          <template>
          <el-table :data="cluetracktable" border style="width: 100%">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column prop="trackDate" label="跟踪日期" width="120"></el-table-column>
            <el-table-column prop="trackStatus" label="线索状态" width="120" >
              <template slot-scope="scope">
                <dictname category="track_status" :v="scope.row.trackStatus"></dictname>
              </template>
            </el-table-column>
            <el-table-column prop="trackContent" label="跟踪内容" width="300"></el-table-column>
            <el-table-column prop="euType" label="客户类型" width="100">
              <template slot-scope="scope">
                <dictname category="xseutype" :v="scope.row.euType"></dictname>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                fixed="right"
                width="100"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.id " style="text-align: left;">
                  <el-button
                      type="text"
                      size="small"
                      style="padding: 0;"
                      class="h-tableLink h-btn"
                      @click="deletecluetrack(scope.row.id)">
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
        </div>
      </el-dialog>-->
        <!--日志追踪详情弹出框-->
      <el-dialog :close-on-click-modal="false"  @close='closeCluedetails' :visible.sync="cluedetailsDialog" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>线索日志</h1>
                    </div>
                </div>
            </div>
            <div style="padding-top: 12px;">
                <template>
                    <el-table :data="cluetracktable" border style="width: 100%">
                        <el-table-column label="序号" type="index" width="50"></el-table-column>
                        <el-table-column prop="pushDate" :show-overflow-tooltip="true" label="分发时间" width="150"></el-table-column>
                        <el-table-column prop="pushUserCode" :show-overflow-tooltip="true" label="接收人编码" width="120" >  </el-table-column>
                        <el-table-column prop="pushUserName" :show-overflow-tooltip="true" label="接收人姓名" width="120" >  </el-table-column>
                        <el-table-column prop="pushNodeName" :show-overflow-tooltip="true" label="线索节点" width="100"></el-table-column>

                        <el-table-column prop="isTimeOut" :show-overflow-tooltip="true" label="处理状态" width="100">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isTimeout == 1">已超时</span>
                                <span v-if="scope.row.isTimeout == 0">已处理未超时</span>
                                <span v-if="scope.row.isTimeout == 2">待处理</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pushRole" :show-overflow-tooltip="true" label="接收人角色" width="100"></el-table-column>
                        <el-table-column prop="createRole" :show-overflow-tooltip="true" label="操作人角色" width="100"></el-table-column>
                        <el-table-column prop="operaterType" :show-overflow-tooltip="true" label="操作方式" width="100"></el-table-column>
                        <el-table-column prop="carryDate" label="处理时间" width="150"></el-table-column>
                        <el-table-column prop="cuname" label="操作人" width="100"></el-table-column>

                    </el-table>
                </template>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" @close='undertakeClose' :visible.sync="undertakeDialog" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>线索承接</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;">
                    <el-form ref="form" :model="f"
                             :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
                        <el-form-item label="省" prop="province"  class="h-elformWrap-2">
                            <el-input v-model="f.province" placeholder="省" readonly ></el-input>
                        </el-form-item>

                        <el-form-item label="市" prop="city"   class="h-elformWrap-2">
                            <el-input v-model="f.city" placeholder="市" readonly ></el-input>
                        </el-form-item>

                        <el-form-item label="渠道" prop="channelName"  class="h-elformWrap-2">
                            <el-input v-model="f.channelName" placeholder="渠道" readonly ></el-input>
                        </el-form-item>

                        <el-form-item label="需求名称" prop="channelName"  class="h-elformWrap-2">
                            <el-input v-model="f.projectName" placeholder="渠道" readonly ></el-input>
                        </el-form-item>


                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="undertakeClose">取消</el-button>

                    <el-button class="h-btn h-bBtn h-bgblue2"  @click="undertake(f.id,1)" >承接-转商机
                    </el-button>
                    <el-button  class="h-btn h-bBtn h-bgblue2" @click="undertake(f.id,2)" >承接-无效信息
                    </el-button>
                    <el-button  class="h-btn h-bBtn h-bgred"  v-if="f.taskType==0"  @click="undertake(f.id,3)" >拒绝承接
                    </el-button>

                </div>
            </div>

        </el-dialog>



        <!-- 新建漏斗弹出层-->
      <el-dialog :close-on-click-modal="false" @close='closeloudmainDialog' :visible.sync="loudmainDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>新建漏斗</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;" class="dialogout X-dai">
            <el-form :model="loudmain" label-position="right" :inline="true" label-width="130" :rules="editloudRules"
                     class="demo-ruleForm h-formbLine h-formbnpm Line1">

              <el-form-item label="区域" prop="areaCode"
                            :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                <brselect category="show_area" v-model="areaCode" :v="areaCode"  :clearable="true"
                :disabled="this.disabled" @change="matchsalesman($event, 'addfunnel')"></brselect>
              </el-form-item>
              <el-form-item label="省" prop="province"
                            :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                <el-select v-model="loudmain.province"  filterable clearable  @change="handleItemChange1($event)" placeholder="省" style="width: 100%;">
                  <el-option
                      v-for="item in shenglist"
                      :key="item.value"
                      :label="item.name"
                      :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="市" prop="city"
                            :rules="[{ required: true, message: '请输入市', trigger: 'change'},]">
                <el-select v-model="loudmain.city" filterable clearable @change="handleItemChange2($event)"
                           :rules="[{ required: true, message: '请输入市', trigger: 'change'},]"
                           placeholder="市" style="width: 100%;">
                  <el-option
                      v-for="item in cityList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="销售人员" prop="salesman">
                <el-select v-model="loudmain.salesman" @change="salesmanChange($event, 'addfunnel')"
                           placeholder="销售人员" style="width: 100%;">
                  <el-option
                      v-for="item in salesmanList"
                      :key="item.id"
                      :label="item.userName"
                      :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="渠道" prop='customerChannel'>
                <brselect category="sales_region" v-model="loudmain.customerChannel" :v="loudmain.customerChannel" :clearable="true"
                          :disabled="this.disabled"/>
              </el-form-item>

              <el-form-item label="项目名称" prop='projectName'>
                <el-input v-model="loudmain.projectName" :disabled="this.disabled">
                </el-input>
              </el-form-item>

              <el-form-item label="项目分类" prop='probjectSorts'>
                <brselect category="message_type" v-model="loudmain.probjectSorts" :v="loudmain.probjectSorts" :clearable="true"
                          :disabled="this.disabled"/>
              </el-form-item>

              <el-form-item label="机会分类" prop='chanceType'>
                <el-select v-model="loudmain.chanceType" :v="loudmain.chanceType" :clearable="true">
                  <el-option v-for="(item) in loudmain.xiangmu"
                             :key="item.code"
                             :label="item.name"
                             :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="跟单商类别" prop='documentaryType'>
                <brselect category="gendanshang" v-model="loudmain.documentaryType" :v="loudmain.documentaryType" :clearable="true"
                          :disabled="this.disabled" @change="entrypartner"/>
              </el-form-item>

              <el-form-item v-if="loudmain.documentaryType == 2" label="合作人名称" prop='partner'>
                <el-input v-model="loudmain.partner" :disabled="this.disabled">
                </el-input>
              </el-form-item>

              <el-form-item label="签约经销商" prop="agentName" v-if="loudmain.documentaryType == 1">
                <el-select v-model="loudmain.agentName" remote filterable :filter-method="showComList" clearable
                           placeholder="请输入"
                           :remote-method="showComList" @change="showComList" :disabled="this.disabled">
                    <el-option v-for="(item) in agentList"
                             :key="item.customerName1"
                             :label="item.customerName1"
                             :value="item.customerName1">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="用户单位" prop="customerName">
                <el-select v-model="loudmain.customerName" remote filterable :filter-method="showGroupList" :clearable="true"
                           style="width: 135px;"
                           placeholder="请输入"
                           :remote-method="showGroupList" @change="showGroupList" :disabled="this.disabled">
                  <el-option v-for="(item,index) in customerNameList"
                             :key="index"
                             :label="item.deptName"
                             :value="item.deptName">
                  </el-option>
                </el-select>
                <i class="el-icon-circle-plus" @click="createAddress"></i>
              </el-form-item>

              <el-form-item label="部门/科室" prop='deptName'>
                <el-input v-model="loudmain.deptName" :disabled="this.disabled">
                </el-input>
              </el-form-item>

              <el-form-item label="负责人" prop='chargePerson'>
                <el-input v-model="loudmain.chargePerson" :disabled="this.disabled">
                </el-input>
              </el-form-item>

              <el-form-item label="电话" prop='phone'>
                <el-input v-model="loudmain.phone" :disabled="this.disabled">
                </el-input>
              </el-form-item>

              <el-form-item label="场景" prop='scenesType'>
                <brselect category="crm_changjing_type" v-model="loudmain.scenesType" :v="loudmain.scenesType" :clearable="true"
                          :disabled="this.disabled"/>
              </el-form-item>

              <el-form-item label="节点" prop='statusR'>
                <brselect category="xinxi_jiedian" v-model="loudmain.statusR" :v="loudmain.statusR" :clearable="true"/>
              </el-form-item>

              <el-form-item label="成单率" prop='childMsgId'>
                <brselect category="xinxi_jiedian_zijiedian" v-model="loudmain.childMsgId" :v="loudmain.childMsgId"
                          :clearable="true"/>
              </el-form-item>

              <el-form-item label="预计下单时间" :required="true">
                <el-date-picker
                    v-model="loudmain.expOnlineDate"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="预计转化时间" :required="true">
                <el-date-picker
                    v-model="loudmain.expConvDate"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>

              <div>
                <el-button @click="addProduct()" type="text" size="mini"
                           style="float:right;font-size:20px;margin-right: -5px" icon="el-icon-circle-plus"
                           circle></el-button>

                <div v-for="(listIt, index) in loudmain.products" :key="index" class="h-formBox">
                  <el-button @click="deleteProduct(index)" v-show="index != 0" type="text"
                             style="float:right;font-size:20px;margin-right: -5px;color:#dc143c;" size="mini"
                             icon="el-icon-remove" circle></el-button>

                  <el-form-item label="链群" prop='lianqun' style="margin-left: -15px; margin-right: -15px">
                    <brselect category="xsyb_lianqun" v-model="loudmain.products[index].lianqun"
                              @change="changeLianqun($event,index)"
                              :v="loudmain.products[index].lianqun" :clearable="true"/>
                  </el-form-item>

                  <el-form-item label="产品型号">
                    <el-select v-model="loudmain.products[index].proModel" :title="loudmain.products[index].proModel" remote
                               filterable :filter-method="showProductByNameList"  placeholder="请输入"
                               :remote-method="showProductByNameList" @change="changeProducts($event,index)">
                      <el-option v-for="(item,index) in productByNameList"
                                 :key="index"
                                 :label="item.proModel"
                                 :value="item.proModel">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="金额" style="margin-left: -15px; margin-right: -15px" >
                    <el-input v-model="loudmain.products[index].price"  remote   oninput="value=value.replace(/[^\d.]/g,'')">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="数量" prop="grabBill">
                    <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="loudmain.products[index].num"></el-input>
                  </el-form-item>

                </div>

              </div>

            </el-form>

          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="closeloudmainDialog">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitLoudmain()">提交</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 新建用户单位-->
      <el-dialog :close-on-click-modal="false"  @close='closeDialogUser' :visible.sync="institutionalX" class="h-dialog2">
        <companyName ref="companyName" :titleName = "titleDig" :add1 = "addUser" :stVal="stVal" @getChildValue="closeCompanyName"></companyName>
      </el-dialog>

      <!--指派-->
      <el-dialog :close-on-click-modal="false"  @close='designateDia' :visible.sync="designateDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>线索指派</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" label-position="right" :inline="true" label-width="80" :rules="editFormRules"
                     class="demo-ruleForm h-formbLine h-formbLine1">

              <el-form-item label="区域" prop="areaCode">
                <brselect category="show_area" v-model="add.areaCode" :v="add.areaCode" :clearable="true"
                :disabled="this.disabled"  @change="matchsalesman($event, 'assignclues')" ></brselect>
              </el-form-item>

              <el-form-item label="省" prop="province">
                <el-select v-model="add.province" @change="handleItemChange1($event)" placeholder="省" style="width: 68%;">
                  <el-option
                      v-for="item in shenglist"
                      :key="item.value"
                      :label="item.name"
                      :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="市" prop="city">
                <el-select v-model="this.add.city" @change="handleItemChange2($event)"
                           :rules="[{ required: true, message: '请输入市', trigger: 'change'},]"
                           placeholder="市" style="width: 100%;">
                  <el-option
                      v-for="item in cityList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="销售人员" prop="salesman">
                <el-select v-model="this.add.salesManName" @change="salesmanChange($event, 'assignclues')"
                           placeholder="销售人员" style="width: 100%;">
                  <el-option
                      v-for="item in salesmanList"
                      :key="item.id"
                      :label="item.userName"
                      :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>

            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="designateDia">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="designatecommit()">提交</el-button>
          </div>
        </div>
      </el-dialog>

      <!--线索催办弹出框-->
      <el-dialog :close-on-click-modal="false"  @close='closeCluePress' :visible.sync="cluepressDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="BscCluePress" label-position="right" :inline="true" label-width="80"
                     class="demo-ruleForm h-formbLine h-formbLine1">
              <el-form-item label="催办日期" prop="pressDate" >
                <el-input
                    v-model="BscCluePress.pressDate" :disabled="true" style="width: 190px;">
                </el-input>
              </el-form-item>

              <el-form-item  label="催办原因" class="h-elformWrap-1" prop="pressContent">
                <el-input type="textarea" v-model="BscCluePress.pressContent" placeholder="请输入" class="h-txtareaBox" rows="3" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="closeCluePress">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="press()">提交</el-button>
          </div>
        </div>
        <template>
          <el-table :data="cluepresstable" border style="width: 100%">
            <el-table-column label="序号" type="index" width="55"></el-table-column>
            <el-table-column prop="cuname" label="催办人" width="70"></el-table-column>
            <el-table-column prop="pressDate" label="催办日期" width="140"></el-table-column>
            <el-table-column prop="pressContent" label="催办原因" >
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content" width="200"><pre align="left"  style="max-width: 500px;white-space: pre-wrap;">{{scope.row.pressContent}}</pre></div>
                  <pre align="left" >{{scope.row.pressContent}}</pre>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="pnum" label="催办次数" width="145" >
              <template slot-scope="scope">
                第 {{ scope.row.pnum }} 次催办
              </template>
            </el-table-column>
          </el-table>
        </template>

      </el-dialog>
      <!--批量催办弹框-->
      <el-dialog :close-on-click-modal="false"  @close='closeCluePress' :visible.sync="batchpressDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="BscCluePress" label-position="right" :inline="true" label-width="80"
                     class="demo-ruleForm h-formbLine h-formbLine1">
              <el-form-item label="催办日期" prop="pressDate" >
                <el-input
                    v-model="BscCluePress.pressDate" :disabled="true" style="width: 190px;">
                </el-input>
              </el-form-item>

              <el-form-item  label="催办原因" class="h-elformWrap-1" prop="pressContent">
                <el-input type="textarea" v-model="BscCluePress.pressContent" placeholder="请输入" class="h-txtareaBox" rows="3" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="closeCluebatchPress">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="batchpress()">提交</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 导入列表弹出框 可以下单的漏斗界面 @choseObj 回调函数 -->
      <clue :visible.sync="clueimport" v-if="clueimport"  @getChildValue="LoudParts" title="线索导入列表"/>

      <div class="h-tableB h-mrt30">
          <div class="h-tableBL" style="margin-left: 23px"  v-if="!dlsflag" >
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="deletebatchSingle">批量删除
            </el-button>
<!--            <el-button  class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="batchPress">批量催办
            </el-button>-->
            <el-button  class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="toimport">导入列表
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">导出
            </el-button>
<!--            <el-button
                class="h-btn h-formBtn h-bgblueQ"
                icon="h-el-icon h-el-icon-export"
                @click="uploaddownexcelflagbtn">
              导入
            </el-button>导入没做好暂时取消-->
            <uploaddownexcel
                :visible.sync="uploaddownexcelflag"
                v-if="uploaddownexcelflag"
                clsname="bscClueManageExcel"
                :startrow="2"
                @callback="uploadExcelFilecallback"/>

          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
          </div>
        </div>

    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import cost from '../../../routes/cost';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from "moment";
import uploaddownexcelbyrole from "../../../components/uploaddown/uploaddownexcelbyrole";
import companyName from "@/components/basic/companyName.vue";
export default {
    components: {
      companyName,
      Treeselect,uploaddownexcel
    },
    data() {
        return {
          institutionalX:false,
          // 展开折叠筛选
          isScreen:false,
          dlsflag : false,
          closeScreen:require("@/assets/images/pimg/closeallic.png"),
          drawScreen:require("@/assets/images/pimg/dobleArr.png"),
            q:{
              daqu:'',
              areaName:'',
              salesManName:'',
              userUnitName:'',
              chainGroup:'',
              proCategory:'',
              channelName:'',
              clueFrom:'',
              trackStatus:'',
              funnelCode:'',
              startDate:'',
              endDate:'',
              cusername:'',
              state:'',
              incomingCall:'',
              telephone:'',
              pageSize: 10,
              pageNo: 1,
              total: 0,
            },
            size:'',
            tableData: [
              {
                daqu:'',
                areaCode:'',
                areaName:'',
                province:'',
                city:'',
                salesManCode:'',
                salesManName:'',
                channelCode:'',
                channelName:'',
                clueFrom:'',
                userUnitCode:'',
                userUnitName:'',
                dept:'',
                leader:'',
                telephone:'',
                chainGroup:'',
                proCategory:'',
                funnelCode:'',
                trackStatus:'',
                userRequire:'',
                memo:'',
                cdate:'',
                doProjectFlag:false,

              }
            ],

            add:{
              id:'',
              areaCode:'',
              province:'',
              city:'',
              salesManName:'',
              salesManCode:'',
              channelCode:'',
              clueFrom:'',
              userUnitName:'',
              userUnitCode:'',
              dept:'',
              leader:'',
              incomingCall:'',
              telephone:'',
              proCategory:'',
              funnelCode:'',
              userRequire:'',
              memo:'',
              chainGroup:'',
              chainCode:'',
              ids: [],  //checkbook 的 id
              trackStatus:'',
              emergency:'',
            },
          //线索跟踪详情
      /*    cluetracktable:[
              {
                id: '',
                mainId: '',
                trackDate: '',
                trackStatus: '',
                trackContent: '',
                memo: '',
              }
          ],*/
            //线索跟踪详情
            cluetracktable: [
                {
                    id: '',
                    mainId: '',
                    pushDate: '',
                    pushUserCode: '',
                    pushUserName: '',
                    pushNode:'',
                    pushNodeName:'',
                    cucode:'',
                    cuname:'',
                    wlBid:'',
                    memo: '',
                    carryDate:'',
                    isTimeout:'',
                }
            ],
          //催办详情
          cluepresstable:[],
          BscClueTrack:{
            id: '',
            mainId: '',
            trackDate: '',
            trackContent: '',
            trackStatus: '',
            memo: '',
            scenesType: '',
            euType:'',
            legalPerson:'',
            email:'',
            user:'',
            signingType:'',
            products: [{
              lianqun: '',
              price: '',
              proModel: '',
              proCode: '',
              num: null,
            }],
            },
          BscCluePress:{
            id: '',
            mainId: '',
            pressDate: '',
            pressContent: '',
            pnum: '',
            cuname: '',
            ids:[],
          },
          rowid:'',   //行 id
          loudid:'', // 漏斗编号
          row:'',   //行
          //信息漏斗表单
          loudmain: {
            xiangmu: [],
            salesman: null, // 销售人
            provinceId: null,
            province: null,
            provinceList: null,
            areaCode: null,  // 目前没有用
            areaName: null,  // 区域/ 省份名称
            shenglist: [],  // 省份 list
            id: null, // 主键ID
            projectId: null, // 项目id
            projectName: null, // 需求名称
            probjectSorts: null, // （CSW城市网，XM大项目，SD散单）
            projectType: null, // 项目类型0内销1外销2采购3展会
            statusR: null, // 节点  R0:方案交互  R1:需求锁定  R2:预算提报  R3:预算批准  R4:招标挂网  R5:转化收入 R6 已转化 R7 已丢标
            expectConvertDate: null, // 报单日期
            customerChannel: null, // 渠道
            city: null,//地市
            customerCode: null, // 用户编码
            customerName: null, // 客户名称
            deptName: null, // 部门/科室
            chargePerson: null, // 负责人
            phone: null, // 电话
            chanceType: null, // 机会分类
            expOnlineDate: null, // 预计挂网时间
            weekInfos: null,// 周
            // brandDate:null, // 中标时间
            expConvDate: null, // 预计转化时间
            documentaryType: null, // 跟单商别（直单/经销商/合伙人）
            partner: null, // 合伙人名称
            partneritem: null,//合伙人名称 临时的
            agentCode : null,  // 经销商编码
            remark: null, // 备注
            cucode: null, // 创建人编码
            cuname: null, // 创建人名称
            cdate: null, // 创建时间
            lucode: null, // 更新人编码
            ldate: null, // 最后更新时间
            delflag: null, // 可用标志  1: 可用, 0: 不可用
            brandModel: null,
            delReason: null,
            price: null,
            num: null,
            proCode: null,
            scenesType: null,
            updateStatus: null,
            loudfuncode: null,
            products: [{
              lianqun: '',
              price: '',
              proModel: '',
              proCode: '',
              num: null,
            }],
            lianqun: null,
            status: null,
            clueid: null, //线索管理的id

          },
          areaCode: null,  // 目前没有用
          isloud:false,

          //信息漏斗 表单 用户单位
          addUser: {
            id: '',
            deptName: '',
            //赋初值
            deptType: 'N',
            leader: '',
            phone: '',
            email: '',
            status: '',
            countryId: '',
            country: '',
            provinceId: '',
            province: '',
            cityId: '',
            city: '',
            areaId: '',
            landmark:'',
            area: '',
            address: '',
            shengobj: '',
            shiobj: '',
            quobj: '',
            selectId: '',
            subFlag: '',
            deptSourceChannel: '',
            longitude: '',
            latitude: '',
            parentCode: '',
            schoolTypeName: '',
          },

            shenglist:[],      //省份list
            salesmanList: [],  // 销售人员list
            cityList: [],      //城市list
            customerNameList: [], //用户单位list
            agentList: [],      //签约经销商
            deptNameList: [],  //单位名称
            addressTypeList:[],
            options: [],      //父级
            stVal: null,
            lianqun: '',
            productByNameList: [],
            multipleSelection: [],  //获取选中 表格的集合

            proSelect: {
              pcode: 0,
              level: 1,
            },

            shenglists: [],
            arealists2: [],
            arealists3: [],


            times:[],
            qweekList :[],
            sexList:[0,1],

            //表单弹出窗 属性设置
            newDialog:false,
            writeNissin:false,
            editDialog:false,
            cluetrackDialog:false,
            cluedetailsDialog:false,
            undertakeDialog: false,  //承接对话框
            loudmainDialog:false,
            newDialogUser:false,
            designateDialog:false,  //用于指派的对话框
            cluepressDialog:false,  //用于催办的弹出框
            batchpressDialog:false,  //用于批量催办的弹出框
            clueimport:false,       //用于线索导入弹出框
            //是否禁用
            disabled: false,
            euTypeFlag:false,
            //批量导入
            uploaddownexcelflag: false,
            daqujlFlag:false,
            xiansuouser:false,
            adminFlag:false,
            usercode:'',


            yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
            weekList:[],
            nissin:{
              answerTime:'',
              defultFlag:'',
              dailyQuestion:'',
              customerName:'',
              visitDate:'',
              endDate:'',
              visitContent:"",
              dailyContent:'',
              isProject: 0,
              id:'',
              isConShow:false,
              isProjectBtn:false,
              chainGroupName:'',
              chainGroupCode:'',
              visitEffect:'',
              title:'',
              statusR:'',
              selectVisitEffect:['a','b'],
              gameTitles: [],
              subJieProgess: [], // 需求子节点数据
              childMsgId: '',
              //yucePrice: '', // 月预算在下单
              expConvDate: '',
              department:'',
              telephone:'',
              contactUserName:"",
              lianqunCode:'',
            },

            authTypeListEdit:[],
            wirteNissinList:[],
            disEdit:false,
            workList:[],
            deptList: [],
            userLists:[],
            custNameList:[],
            quyuList: [],
            AuthoCheck: '',
            authTypeList: [],
            userList: [0],
            weekPlanList:[],
            groupList: [],
            groupArr:[],
            titleDig:"",
            optionList:[],
            projectList:[],
            qyearList:[],
          editFormRules: {
            areaCode:[{required: true, message: '请输入必填项', trigger: 'change'}],
            province:[{required: true, message: '请选择省', trigger: 'change'}],
            channelCode:[{required: true, message: '请输入必填项', trigger: 'change'}],
            salesManName:[{required: true, message: '请输入必填项', trigger: 'blur'}],
            clueFrom:[{required: true, message: '请输入必填项', trigger: 'change'}],
            telephone:[{required: true, message: '请输入必填项', trigger: 'blur'}],
            trackDate:[{required: true, message: '请输入必填项', trigger: 'blur'}],
            trackContent:[{required: true, message: '请输入必填项', trigger: 'blur'}],
            userRequire:[
                {required: true, message: '请输入必填项', trigger: 'blur'},
                {max:50, message: '长度不得大于50个字符', trigger: 'blur'}
            ],
          },

          editloudRules: {
            cuname: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            customerChannel: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            city: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            projectName: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            probjectSorts: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            expOnlineDate: [{required: true, message: '请输入必填项', trigger: 'change'}],
            expConvDate: [{required: true, message: '请输入必填项', trigger: 'change'}],
            scenesType: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            // area: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            documentaryType: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            statusR: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            lianqun: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            customerName: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            childMsgId: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            salesman: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            chanceType: [{required: true, message: '请输入必填项', trigger: 'blur'}]
          },
          cluesList:[],

            //表单
            f:{

                id: '',
                province: '',
                city: '',
                salesManName: '',
                salesManCode: '',
                channelCode: '',
                channelName:'',
                clueFrom: '',
                userUnitName: '',
                userUnitCode: '',
                telephone: '',
                proCategory: '',
                funnelCode: '',
                userRequire: '',
                memo: '',
                chainGroup: '',
                chainCode: '',
                ids: [],  //checkbook 的 id
                trackStatus: '',
                assignType: ''//指派类型 1区域销售人员 2经销商

            },
        }
    },
    methods: {
      //明细导出
      exportExcel() {
        updownfile.down("/api/swyl/v1/guanhuai/bscClueManage/newDownloadExcel",this.q,"post",'data');
      },
      // 批量 导出
      uploaddownexcelflagbtn() {
        this.uploaddownexcelflag = true;
      },
      uploadExcelFilecallback(rd) {
        this.uploaddownexcelflag = false;
        this.query();
        this.$msg.msgs(rd.msg);
        this.clueimport = true;
      },
        showFormList(value) {
            ss.MuBiao.getUser(value).then(res => {
                this.optionList = res.msg
            })
          if (this.optionList.length == 1){
            this.custCode = this.optionList.userCode;
          }
        },
        //项目类型
        getProject(){
            ss.MuBiao.getProject().then(res => {
                this.projectList = res.msg
            })
        },
        // getDept(q){
        //   ss.MuBiao.getDeptList(q).then(rd => {
        //     this.deptList = rd;
        //   })
        // },
      getcust(q){
          ss.MuBiao.getUser(q).then(rd => {
            this.userLists = rd;
          })
        },
      employeesdetails(o){
        this.$router.push(
            {
              //添加需要传值到那个页面的路径
              path:'loudnew/LoudMain',
              //携带需要传递的参数
              query:{funcode:o}
            })
      },

      getcustName(q){
        ss.MuBiao.getUser(q).then(rd => {
          this.custNameList = rd;
          // console.log("-------------------")
          // console.log(this.custNameList);
        })
      },

        getKnowWeek() {
          var week1 = this.getWeekNum();
          this.qweekList.forEach(element => {
            if(week1 == element.week){
              this.q.week = element.week
            }
          });
        },
        getqWeeks(y,z){
          ss.MuBiao.getWeekList({year:y,stype:z}).then(rd => {
            this.qweekList = rd;
            this.getKnowWeek();
          })
        },
        groupListMe() {
            var data  = this.add.customerName
             ss.MuBiao.getUser(data).then(res => {
                this.groupList = []
                this.groupArr = []
                this.groupList = res.msg
                for(let item of this.groupList) {
                    this.groupArr.push({
                        value:item.userName,
                        id:item.userCode
                    })
                }
             })
        },

      //获取今年是第几周
      getWeekNum() {
        //获得当前日期是第几周的方法
        var year = new Date().getFullYear();
        var week = moment(new Date()).format("E");//获得今天是星期几
        var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
        //今天到1月1号的时间戳之差
        var millisDiff =
            new Date(moment().format("yyyy-MM-DD")).getTime() -
            new Date(year + "-01-01").getTime();
        var days =
            (millisDiff -
                week * (24 * 60 * 60 * 1000) -
                (7 - startweek) * (24 * 60 * 60 * 1000)) /
            86400000;
        return days / 7;
        //这里加的2代表的是本周和今年1月1号所在的那一周
      },

      //改动和并列的
      arraySpanMethod() {
       this.$nextTick(() =>{
         if(this.$refs.multipleTable.$el){
           var current = this.$refs.multipleTable.$el
               .querySelector(".el-table__footer-wrapper")
               .querySelector(".el-table__footer");
           var cell = current.rows[0].cells;
           cell[0].style.display = "none";
           cell[1].style.display = "none";
           cell[2].style.display = "none";
           cell[3].style.display = "none";
           cell[4].style.display = "none";
           cell[5].style.display = "none";
           cell[10].style.display = "none";
           cell[6].classList.remove('is-left');
           cell[6].colSpan = "7";
         }
       })
      },

      query() {
          this.selectPageAll();
          if (this.$store.getters.hasRole('swyl_gndailishang') ) {
              this.dlsflag = true;

          }
      },

      deleteSingle(id){
        //
        var data = id
        this.$confirm('确定删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ss.BscClueManage.deleteById(data).then(res => {
            console.log(res)
            if(res.f == true ){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.selectPageAll()
            }else{
              this.$message.error(res.msg);
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },

      deletebatchSingle(){
        if (this.multipleSelection.length == 0 || this.multipleSelection == null){
          this.$message.error("没有选中可以删除的!");
          return false;
        }
        this.multipleSelection.forEach(element => {
          this.BscCluePress.ids.push(element.id);
        });
        var data = {
          ids:this.BscCluePress.ids,
        }
        this.$confirm('确定要删除数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ss.BscClueManage.deletebatchById(data).then(res => {
            console.log(res)
            if(res.f == true ){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.selectPageAll()
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //删除线索跟踪记录
      deletecluetrack(id){
        //
        var data = id
        this.$confirm('确定删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ss.BscClueManage.deletecluetrack(data).then(res => {
            console.log(res)
            if(res.f == true ){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              //根据id查询线索跟踪
              this.selectCluetrack()
            }else{
              this.$message.error(res.msg);
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },

      updateDetail(row){
        //查询大区域下所有销售用户
    this.allSalemanfuction();
        this.authTypeListEdit=[]
        this.titleDig="修改内容"
        var data = row.id
        this.loadArea();
        ss.MuBiao.getbscConcactpersonSingle(data).then(res =>{
          console.log("--------------");
          console.log(res.msg);
          this.authTypeListEdit = res.msg;
          this.add = res.obj;
          //查询区域和渠道下的销售人员
          if (this.add.areaCode != null && this.add.areaCode != '' && this.add.channelCode != null && this.add.channelCode != '') {
            var data = {
              "areaCode": this.add.areaCode,
              "channelCode": this.add.channelCode
            }
            ss.netApi.userNamesBydaquSale(data).then(res => {
              //通过渠道给销售人员赋值
              console.log(res.obj, "res.obj111");
              this.salesmanList = res.obj;
              console.log(this.salesmanList, "this.salesmanList");
              //需要的数据进行封装放入下拉集合中
              var newdata = {
                "id": this.add.salesManCode,
                "userName": this.add.salesManName,
                "userCode": this.add.salesManCode
              }
              //防止区域编码和渠道编码查询出来的数据和修改带出来的默认值重复
              for(var i=0; i< this.salesmanList.length;i++){
                if(this.add.salesManCode != this.salesmanList[i].userCode){
                  this.salesmanList.push(newdata);
                }
              }
              //给默认值销售人员工号和name拼接
              this.add.salesManName = this.add.salesManName + "(" + this.add.salesManCode + ")";
              //给默认值销售人员工赋值
              this.add.salesManCode = this.add.salesManCode;
            })
          }

        })
        this.editDialog = true
      },
      //催办
      savePress(row){
        this.titleDig="催办"
        this.BscCluePress.mainId = row.id;
        this.loudid = row.funnelCode;
        this.row = row;
        this.rowid = row.id;
        this.BscCluePress.pressDate = this.myFunction();
        //根据id查询催办
        this.BscCluePress.ids = [];
        this.selectCluepress();
        this.cluepressDialog = true
      },
      //批量催办
      batchPress(){
        if (this.multipleSelection.length == 0 || this.multipleSelection == null){
          this.$message.error("没有选中可以催办的!");
          return false;
        }
        this.multipleSelection.forEach(element => {
          this.BscCluePress.ids.push(element.id);
        });
        this.titleDig="批量催办"
        this.BscCluePress.pressDate = this.myFunction();
        this.batchpressDialog = true
      },
      //催办
      press(){
        // var data = this.row.id
        var data = {
          id:this.row.id,
          pressContent:this.BscCluePress.pressContent
        }
        this.$confirm('您确定要催办?', '催办', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ss.MuBiao.press(data).then(res =>{
            if (res.obj == "ok"){
              this.$message({
                type: 'info',
                message: '催办成功!'
              });
              this.selectCluepress();
              this.query();
              this.closeCluePress();
            }else {
              this.$message({
                type: 'info',
                message: '催办失败!'
              });;
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消!'
          });
        });
      },
      //批量催办
      batchpress(){
        var data = {
          ids:this.BscCluePress.ids,
          pressContent:this.BscCluePress.pressContent
        }
        this.$confirm('您确定要催办?', '催办', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ss.MuBiao.batchpress(data).then(res =>{
              this.$message({
                type: 'info',
                message: '催办成功!'
              });
              this.query();
              this.closeCluebatchPress();
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消!'
          });
        });
      },

      //批量催办
      toimport(){
        this.clueimport = true
      },
      addZero(i) {
        if (i < 10) {
          i = "0" + i;
        }
        return i;
      },
      myFunction() {
        var d = new Date();
        var month = this.addZero(d.getMonth()+1)
        var day = this.addZero(d.getDate())
        var h = this.addZero(d.getHours());
        var m = this.addZero(d.getMinutes());
        var s = this.addZero(d.getSeconds());
        return d.getFullYear()+"-"+month+"-"+day+" "+ h + ":" + m + ":" + s;
      },
      //添加线索详情
      saveClue(row){
       /* //判断能不能提交
        if(this.daqujlFlag && row.fillinStatus == 48){
          this.$message.error("线索已超过48小时不可闭环!");
          return;
        }
        //判断能不能提交
        if(this.usercode == row.cusercode && row.fillinStatus == 48){
          this.$message.error("线索已超过48小时不可闭环!");
          return;
        }
        //判断能不能提交
        if(!(this.xiansuouser || this.adminFlag)  && row.fillinStatus == 96){
          this.$message.error("线索已超过96小时不可闭环!");
          return;
        }*/
        this.titleDig="线索跟踪"
        this.BscClueTrack.mainId = row.id;
        this.loudid = row.funnelCode;
        this.rowid = row.id;
        this.BscClueTrack.trackDate = this.getNow();
        console.log(this.BscClueTrack),
        this.cluetrackDialog = true
        this.euTypeFlag = false;
        this.BscClueTrack.products = [{
          lianqun: '',
          price: '',
          proModel: '',
          proCode: '',
          num: null,
        }]
      },
      getNow(){
        let date = new Date();
        return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+(date.getDate());
      },
      //查看详情
   /*   selectcluedetails(row){
        this.titleDig="跟踪详情"
        this.BscClueTrack.mainId = row.id;
        console.log(this.BscClueTrack),
        //根据id查询线索跟踪
        this.selectCluetrack(),
        this.cluedetailsDialog = true
      },*/

        //查看流转日志
        selectcluedetails(row){
            var data ={
                "mainId":row.id
            }
            //根据id查询线索跟踪
            ss.BscClueZhaoBiao.selectCluePushLog(data).then(res =>{
                this.cluetracktable = res.records;

            })
            this.cluedetailsDialog = true
        },

        /**
         * 转项目
         * */
        toProject(row){
            this.$router.push({
                path: "/clueToProject",
                query: {id: row.id, fromSource: row.fromSource}
            })
        },
        updateDetailxs(id){
            if(!id){
                this.$msg.msge("无关联id!");
                return ;
            }

            var path = '/infoIndex';
            let routeData = this.$router.resolve({path: path, query: {'id':id}});
            window.open(routeData.href, '_blank');
        },



      //根据id查询线索跟踪
      selectCluetrack(){
        ss.BscClueManage.selectClue(this.BscClueTrack).then(res =>{
          this.cluetracktable = res.msg;
        })
      },
      //根据id查询催办
      selectCluepress(){
        ss.BscClueManage.selectCluepress(this.BscCluePress).then(res =>{
          this.cluepresstable = res.msg;
        })
      },
      //创建漏斗
      createNew() {
        this.cleanAdd();
        var data = this.rowid;
        this.loudmain.clueid = this.rowid;
        ss.MuBiao.getbscConcactpersonSingle(data).then(res =>{
          this.loudmain.areaName = res.obj.areaName;
          this.areaCode = res.obj.areaCode;
          this.loudmain.province = res.obj.province;
          this.loudmain.city = res.obj.city;
          this.loudmain.salesman = res.obj.salesManName;
          this.loudmain.customerChannel = res.obj.channelCode;
          this.loudmain.deptName = res.obj.dept;
          this.loudmain.chargePerson = res.obj.leader;
          this.loudmain.phone = res.obj.telephone;
          if (res.obj.tracks.length > 0){
            this.loudmain.scenesType = res.obj.tracks.scenesType;
            for (let i = 0; i < res.obj.tracks[0].products.length; i++) {
              if (i == 0){
                this.loudmain.products[i].lianqun = res.obj.tracks[0].products[i].lianqun;
                this.loudmain.products[i].price = res.obj.tracks[0].products[i].price;
                this.loudmain.products[i].proModel = res.obj.tracks[0].products[i].proModel;
                this.loudmain.products[i].proCode = res.obj.tracks[0].products[i].proCode;
                this.loudmain.products[i].num = res.obj.tracks[0].products[i].num;
              }else {
                this.addProduct();
                this.loudmain.products[i].lianqun = res.obj.tracks[0].products[i].lianqun;
                this.loudmain.products[i].price = res.obj.tracks[0].products[i].price;
                this.loudmain.products[i].proModel = res.obj.tracks[0].products[i].proModel;
                this.loudmain.products[i].proCode = res.obj.tracks[0].products[i].proCode;
                this.loudmain.products[i].num = res.obj.tracks[0].products[i].num;
              }
            }
          }
          if (res.obj.funnelCode){
            this.$message.error("已转化漏斗不能重复转化!");
          }else {
            this.loudmainDialog = true;
          }
        })
        this.loadArea();
        this.showChanceType(null);
      },
      cleanAdd() {
        this.areaCode = null,
        this.loudmain = {
          xiangmu: [],
          salesman: '',
          id: '', // 主键ID
          projectId: '', // 项目id
          projectName: '', // 需求名称
          probjectSorts: '', // （CSW城市网，XM大项目，SD散单）
          projectType: '', // 项目类型0内销1外销2采购3展会
          statusR: '', // 节点  R0:方案交互  R1:需求锁定  R2:预算提报  R3:预算批准  R4:招标挂网  R5:转化收入 R6 已转化 R7 已丢标
          expectConvertDate: '', // 报单日期
          areaName: '', // 区域
          shenglist: [],// 省份list
          customerChannel: '', // 渠道
          city: '',//地市
          customerCode: '', // 用户编码
          customerName: '', // 客户名称
          deptName: '', // 部门/科室
          chargePerson: '', // 负责人
          phone: '', // 电话
          chanceType: '', // 机会分类
          expOnlineDate: '', // 预计挂网时间
          weekInfos: '', // 周
          // brandDate:null, // 中标时间
          expConvDate: '', // 预计转化时间
          documentaryType: '', // 跟单商别（直单/经销商/合伙人）
          partner: '', // 合伙人名称
          remark: '', // 备注
          cucode: '', // 创建人编码
          cuname: '', // 创建人名称
          cdate: '', // 创建时间
          lucode: '', // 更新人编码
          ldate: '', // 最后更新时间
          delflag: '', // 可用标志  1: 可用, 0: 不可用
          brandModel: '',
          delReason: '',
          price: '',
          num: '',
          products: [{
            lianqun: '',
            grabBill: '',
            proModel: '',
            num: '',
          }],
          lianqun: '',
        },
            this.city = '',
            this.salesman = ''
            //过滤新增的数据
            this.add.province = '',
            this.add.city = '',
            this.add.salesManName= ''
      },

      showChanceType(values, id) {
        this.loudmain.xiangmu = null;
        let chanceTypes = this.$store.getters.dictlist("chance_type_xs");
        let newChanceTypes;
        this.loudmain.xiangmu = this.deepCopy(chanceTypes, newChanceTypes);
        let json = this.loudmain.xiangmu;
        var infos = [];
        for (let i in json ){
          infos.push(json [i])
        }
        this.loudmain.xiangmu = infos;
        var result = false;
        if (values != null) {
          for (let i = 0; i < chanceTypes.length; i++) {
            if (chanceTypes[i].code == values.chanceType) {
              result = true;
              break;
            }
          }
          if (result == false) {
            console.log(values)
            let newXiangmu =
                {
                  "category": "chance_type_xs",
                  "code": values.chanceType,
                  "des": values.chanceTypeName,
                  "id": "",
                  "name": values.chanceTypeName,
                  "pid": "",
                  "refid": "",
                }
            this.loudmain.xiangmu.push(newXiangmu);
          }
        }

        if (id == null) {
          this.loudmain.chanceType = '';
        }
      },

      deepCopy(p, c) {
        var c = c || {};
        for (var i in p) {
          if (typeof p[i] === 'object') {
            c[i] = (p[i].constructor === Array) ? [] : {};
            this.deepCopy(p[i], c[i]);
          } else {
            c[i] = p[i];
          }
        }
        return c;
      },
      //跟单商类别
      entrypartner() {
        if (this.loudmain.documentaryType == 1 || this.loudmain.documentaryType == 3) {
          this.loudmain.partneritem = this.loudmain.partner;
          this.loudmain.partner = "";
        }
        if (this.loudmain.documentaryType == 2) {
          this.loudmain.partner = this.loudmain.partneritem;
          this.loudmain.agentName = '';
          this.loudmain.partner = "";
        }

        if (this.loudmain.documentaryType == 3) {
          this.loudmain.partner = "";
          this.loudmain.agentName = '';
        }
      },
      //签约经销商
      showComList(value) {
        ss.netApi.selectByUserNameLoud(value).then(res => {
          console.log(res)
          this.agentList = res.obj
          this.loudmain.agentCode = res.obj[0].usercode
        })
      },
      //新增收货单位
      createAddress() {
        this.titleDig = "新建用户单位"
        this.institutionalX = true
        /*this.loadAreas();*/
        //获取父级
        this.getParentInfo();
      },
      closeCompanyName(propData){
        console.log(propData);
        this.closeDialogUser();
      },
      //删除产品
      deleteProduct(index) {
        this.loudmain.products.splice(index, 1)
      },
      //删除产品
      deletetrackProduct(index) {
        this.BscClueTrack.products.splice(index, 1)
      },

      //添加产品
      addProduct() {
        this.loudmain.products.push({
          lianqun: '',
          price: '',
          proModel: '',
          proCode: '',
          num: null,
        })
      },
      //添加线索跟踪产品
      addtrackProduct() {
        this.BscClueTrack.products.push({
          lianqun: '',
          price: '',
          proModel: '',
          proCode: '',
          num: null,
        })
      },

      getQuyu(q){
        ss.MuBiao.getQuyuList(q).then(rd => {
          this.quyuList = rd;
        })
      },

      selectPageAll(){
        ss.BscClueManage.getBscClueManage(this.q).then(res => {
          this.tableData = res.msg.records;
          // console.log(this.tableData);
          // console.log(res);d
          this.q.total = res.msg.total;
        })
      },
        querySearchGroup(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup(val) {
             this.add.customerName= val.value
        },
        groupListMe1() {
            var data  = this.edit.customerName
             ss.MuBiao.getUser(data).then(res => {
                this.groupList = []
                this.groupArr = []
                this.groupList = res.msg
                for(let item of this.groupList) {
                    this.groupArr.push({
                        value:item.userName,
                        id:item.userCode
                    })
                }
             })
        },
        querySearchGroup1(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup1(val) {
             this.edit.customerName= val.value
        },
        changeHandler(value) {
            //console.log('改变之后的值是:' + value)
            let data =  this.authTypeList
            let item = this.add.userList
　　　　　　 // 使用find方法根据id查询对应对象
            let a =  data.find((ele)=>{
                return ele.id == item
            });
            var arr3 =a
            if(!arr3.id){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    this.add.clearType = 2
                    this.disEdit = true
                }else{
                    this.add.targetContent = arr3.targetContent,
                    this.add.customerName= arr3.customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3.projectName
                    this.disEdit = false
                    this.add.id = this.add.userList
                }
        },
      //checkbook  获取多选框元素
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //指派
    /*  designate() {
        if (this.multipleSelection.length == 0 || this.multipleSelection == null){
          this.$message.error("没有选中可以指派的!");
          return false;
        }
        // var idlist = [];
        console.log(this.multipleSelection)
        this.multipleSelection.forEach(element => {
          this.add.ids.push(element.id);
        });
        console.log("888888888888888888")
        console.log(this.add.ids)
        this.designateDialog = true;
        this.titleDig="指派";
        this.loadArea();
      },*/
        //指派
        designate(data) {

            this.$router.push({
                path: '/designateClue400',
                query: {id: data.id}
            })
        },
        undertakeOpen(obj){
            this.f =obj;
            this.undertakeDialog = true;

        },

        //关闭承接表单
        undertakeClose(){
            this.undertakeDialog = false
            this.f ={};
        },
        /*承接操作*/
        undertake(id,trackStatus){

            this.$confirm(
                trackStatus === 1 ? '是否确认确认转为商机？' :  trackStatus === 2 ? '是否确认确认转为无效信息？' : '是否确认确认拒绝承接？' ,
                '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'

                })
                .then(_ => {
                    let query = {
                        id: id,
                        trackStatus: trackStatus,
                    }
                    ss.BscClueManage.undertake(query).then(rd => {
                        this.$msg.msgs("提交成功！");
                        this.undertakeClose();
                        this.selectPageAll()
                    })

                })
                .catch(_ => {

                });
        },



      designatecommit(){
        if(!this.add.areaCode){
          this.$message.error("区域没有指派!");
          return false;
        }
        if(!this.add.province){
          this.$message.error("省没有指派!");
          return false;
        }
        if(!this.add.city){
          this.$message.error("城市没有指派!");
          return false;
        }
        if (!this.add.salesManName){
          this.$message.error("销售人员没有指派!");
          return false;
        }
        //过滤销售人员的编码
        var product = _.find(this.salesmanList, {userName: this.add.salesManName});
        this.add.salesManCode = product.userCode;
        ss.BscClueManage.designatecommit(this.add).then(res => {
          if(res.f == true ){
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.selectPageAll()
            this.designateDia()
          }else{
            this.$message.error(res.msg);
            this.designateDia()
          }
        })

      },
      handleFilter() {
        this.query();
      },
        groupChange() {
            if (this.add.userList.length > 1) {
                this.add.userList.shift();
            }
            var arr3 =[]
                this.add.userList.forEach((item) => {
					this.authTypeList.forEach((element) => {
						  if (item == element.id) {
							arr3.push(element)
						  }
					})
                })
                if(arr3.length == 0){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    this.add.clearType = 2
                    this.disEdit = false
                }else{
                    this.add.targetContent = arr3[0].targetContent,
                    this.add.customerName= arr3[0].customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3[0].projectName
                    this.disEdit = true
                    this.add.id = this.add.userList[0]
                }
        },

        getWeeks(y){
            ss.MuBiao.getWeekList({year:y}).then(rd => {
                this.weekList = rd;
            })
        },
        getWeeksBySelectYear(){
            this.getWeeks(this.add.year);
            ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                this.addlianqunList = rd;
            })
        },

        selectWeek(){
            this.getWeekPlan()
        },
        getqWeeksBySelectYear(){
            this.getqWeeks(this.q.year,1);
        },
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        create(){
          this.newDialog = true;
          this.titleDig="新建线索"
          this.loadArea();
        },
        rest(){
          this.q.areaName='',
              this.q.salesManName='',
              this.q.userUnitName='',
              this.q.chainGroup='',
              this.q.proCategory='',
              this.q.channelName='',
              this.q.clueFrom='',
              this.q.trackStatus='',
              this.q.state='',
              this.q.funnelCode='',
              this.q.startDate='',
              this.q.endDate='',
              this.q.incomingCall='',
              this.q.telephone=''
              // pageSize: 10,
              // pageNo: 1,
              // total: 0,
        },
        exit(){
            this.closeDialog()
        },
      showGroupList(value) {
        ss.MuBiao.getUserLoud(value).then(res => {
          console.log(res)
          this.customerNameList = res
          this.loudmain.customerCode = res[0].id
        })
      },
      showGroupClueList(value) {
        ss.MuBiao.getUserLoud(value).then(res => {
          this.customerNameList = res
          this.add.userUnitCode = res[0].id
        })
      },
      //获取单位名称信息
      selectDept(value) {
        ss.nxAddress.getDeptList(value).then(rd => {
          this.deptNameList = rd.msg;
        })
      },

      loadArea(i) {
        let proSelect = {
          pcode: 0,
          level: 1,
        }
        console.log(proSelect)
        ss.Dictservice.arealist(proSelect).then(rd => {
          this.shenglist = rd;
        })
      },

      loadAreas(i) {
        ss.Dictservice.arealist(this.proSelect).then(rd => {
          this.shenglists = rd;
        })
      },

      getdaqujingli(type){

        var areaCode = this.add.areaCode;
        var areaName = this.add.areaName;
        var channelCode = this.add.channelCode;

        //由区域和渠道选着大区经理
        if (areaCode != null && areaCode != '' && channelCode != null && channelCode != '' ){
          this.add.salesManName = '';
          var data  = {
            "areaCode":areaCode,
            "channelCode":channelCode
          }
           //线索新增走新逻辑 在区域查询销售人员逻辑基础上增加通过区域和渠道锁定销售人员
           console.log(data, "585556668552");
          ss.netApi.userNamesBydaquSale(data).then(res => {
            //如果是新增需要给默认值
            if (type == 'addclue') {
              if (res.obj.length == 1) {
                //拼接姓名和工号
                this.add.salesManName = res.obj[0].userName + "(" + res.obj[0].userCode + ")";
                //默认销售用户工号
                this.add.salesManCode = res.obj[0].userCode;
              } else {
                for (var i = 0; i < res.obj.length; i++) {
                  //判断如果有多个销售人需要判断是否是接口人进行默认
                  if (1 == res.obj[i].isDefault) {
                    //拼接姓名和工号
                    this.add.salesManName = res.obj[i].userName + "(" + res.obj[i].userCode + ")";
                    //默认销售用户工号
                    this.add.salesManCode = res.obj[i].userCode;
                  }
                }
              }
            }
            //通过渠道给销售人员赋值
            this.salesmanList = res.obj;
          })
        }
      },

      //选中 区域带出销售人员
      matchsalesman(province,type){

        //选中区域 默认是 显示 直辖市的（市辖区）省
        var areaitem = province.des;
        if (areaitem == '北京' || areaitem == '天津'|| areaitem =='上海' || areaitem == '重庆'){
          areaitem = areaitem + '市';
          this.add.province = areaitem;
          this.add.city = '市辖区'
        }else if (areaitem != '苏州' && areaitem != '深圳'){
          if (areaitem == '广西'){
            areaitem = areaitem + '壮族自治区';
            this.add.province = areaitem;
            this.add.city = '';
          }else if (areaitem == '宁夏'){
            areaitem = areaitem + '回族自治区';
            this.add.province = areaitem;
            this.add.city = '';
          }else if (areaitem == '内蒙古'){
            areaitem = areaitem + '自治区';
            this.add.province = areaitem;
            this.add.city = '';
          }else if (areaitem == '新疆'){
            areaitem = areaitem + '维吾尔自治区';
            this.add.province = areaitem;
            this.add.city = '';
          }else if  (areaitem == '西藏'){
            areaitem = areaitem + '自治区';
            this.add.province = areaitem;
            this.add.city = '';
          }else {
            areaitem = areaitem + '省';
            this.add.province = areaitem;
            this.add.city = '';
          }
        }else {
          this.add.province = '';
          this.add.city = '';
          this.cityList = null;
        }
        //差该区域下的销售人员
        if (type == 'assignclues' || type == 'addfunnel') {
        ss.UserService.selectUserNamesBydaquAndarea(province.des).then(names => {
          this.salesmanList = names.obj;
        })
      }
        //查询 城市列表'
        var product = _.find(this.shenglist, {name: areaitem});
        if (product != null){
          ss.Dictservice.getCity({code: product.code}).then(rd => {
            this.cityList = rd.zlist;
          })
        }
          /**********************点击区域的时候线索新增获取所有区域销售用户****************************************/
        if (type == 'addclue') {
        this.allSalemanfuction();
        }

        //调用默认显示 接口人
        // this.add.salesManName = ''
        // this.getdaqujingli();
      },
       //公共查询所有销售用户
    allSalemanfuction() {
      ss.netApi.userNamesBydaquSale().then(res => {
        //通过渠道给销售人员赋值
        this.allsaleman = null;
        this.allsaleman = res.obj;
        // console.log( this.allsaleman,202310261013);
      })
    },
      // 省份选择器
      handleItemChange1(o, salesman, city) {
        console.log(salesman);
        this.city = city;
        if (city == null) {
          this.city = null;
        }
        if (salesman == null) {
          this.salesman = null;
        }
        this.add.provinceList = _.find(this.shenglist, {code: o});
        this.add.province = this.add.provinceList.name;
        this.loudmain.province = this.add.provinceList.name;
        ss.Dictservice.getCity({code: o}).then(rd => {
          this.cityList = rd.zlist;
        })
      },
      handleItemChange2(o) {
        this.add.city = o;
      },
      salesmanChange(o,type) {
        this.add.salesManName = o;
        console.log(o, "845121258");
        this.add.salesManName = o;
        if (type == 'addclue'||type == 'editclue') {
          this.add.salesManCode = o;
        }
      },
      // 用户单位中 省份选择器
      handleItemChanges1(o) {
        this.addUser.provinceId = o;
        this.address = _.find(this.shenglists, {code: this.addUser.provinceId});
        this.addUser.province = this.address.name;
        ss.Dictservice.areaTreelist({code: o}).then(rd => {
          console.log("rddddddd", rd.zlist)
          this.addUser.city = '';
          this.addUser.area = '';
          this.arealists2 = rd.zlist;
          this.arealists3 = [];
        })
      },
      handleItemChanges2(o) {
        this.addUser.cityId = o;
        this.address = _.find(this.arealists2, {code: this.addUser.cityId});
        this.addUser.city = this.address.name;
        this.arealists3 = _.find(this.arealists2, {code: o}).zlist
        console.log("arealist3", this.arealist3)
        this.arealist4 = []
      },
      handleItemChange3(o) {
        this.addUser.areaId = o;
        this.address = _.find(this.arealists3, {code: this.addUser.areaId});
        this.addUser.area = this.address.name;
      },
      //提交单位用户地址
      commitCreateUser(v) {
        this.addUser.subFlag = '提交';
        this.addUser.countryId = '156';
        this.addUser.country = '中国';
        this.addUser.provinceId = this.addUser.provinceId.substring(0, 6);
        this.addUser.cityId = this.addUser.cityId.substring(0, 6);
        this.addUser.areaId = this.addUser.areaId.substring(0, 6);
        this.addUser.parentCode = this.stVal;
        var data = this.addUser;
        ss.nxAddress.insertAddress(data).then(rd => {
          this.closeDialogUser();
        })
      },
      //提交漏斗
      commitLoudmain() {
        this.loudmain.areaCode = this.areaCode;
        console.log("-------"+this.loudmain.areaCode)
        var data = this.loudmain
        console.log("1111111112222222");
        console.log( this.loudmain.province)
        console.log(this.loudmain)
        ss.loudnew.newSaveOrUpdate(data).then(res => {
          console.log(res)
          if (res.f == true) {
            this.$message({
              type: 'success',
              message: '保存成功!'
            });
            this.handleFilter()
            this.closeloudmainDialog()
            this.closeCluetrack()
          } else {
            this.$message.error(res.msg);
          }
        })

      },
      //获取当前登录人创建的所有父级单位
      getParentInfo() {
        ss.nxAddress.getParentInfo().then(rd => {
          console.log(rd)
          this.options = rd.msg;
          console.log("1111111111111111",this.options)
        })
      },

      //获取产品型号
      showProductByNameList(value1) {
        let value2 = this.lianqun;
        ss.netApi.listByModelProduct(value1, value2).then(res => {
          console.log(res.obj)
          this.productByNameList = res.obj
        })
      },

      //提交漏斗
      changeProducts(value, index) {
        console.log(value);
        console.log(index);
        var product = _.find(this.productByNameList, {proModel: value});
        this.$set(this.loudmain.products[index],"price" , product.price);
        this.loudmain.products[index].proModel = product.proModel
        this.loudmain.products[index].proCode = product.proCode
        this.loudmain.proCode = product.proCode
        this.loudmain.products[index].lianqun = product.lianqun;
      },
      //线索跟踪录入漏斗
      changetrackProducts(value, index) {
        var product = _.find(this.productByNameList, {proModel: value});
        this.$set(this.BscClueTrack.products[index],"price" , product.price);
        this.BscClueTrack.products[index].proModel = product.proModel
        this.BscClueTrack.products[index].proCode = product.proCode
        this.BscClueTrack.proCode = product.proCode
        this.BscClueTrack.products[index].lianqun = product.lianqun;
      },
      changeLianqun(value,index) {
        if (value != undefined){
          this.lianqun = value.code;
        }else {
          this.lianqun = "";
        }
        this.loudmain.products[index].grabBill = '';
        this.loudmain.products[index].proModel = '';
        this.loudmain.products[index].num = '';
        this.$set(this.loudmain.products[index],"price" ,0);
      },
      changetrackLianqun(value,index) {
        if (value != undefined){
          this.lianqun = value.code;
        }else {
          this.lianqun = "";
        }
        this.BscClueTrack.products[index].grabBill = '';
        this.BscClueTrack.products[index].proModel = '';
        this.BscClueTrack.products[index].num = '';
        this.$set(this.BscClueTrack.products[index],"price" ,0);
      },
      //查询当前联系方式有没有录入过
      getTelephone(v){
        ss.BscClueManage.getXsTelephone(this.add.telephone).then(res =>{
          if(res){
            this.$message({
              type: "error",
              message: '该联系方式已存在！'
            });
          }
        })
      },
      //提交表单
      commitCreate() {

            console.log('提交表单',this.add)
          this.$refs['addForm'].validate((valid1) => {
              if (valid1) {
                  this.$msg.confirm("确认提交？",()=>{

                      ss.BscClueManage.insertbcp(this.add).then(res => {
                          console.log(res)
                          if(res.f == true ){
                              this.$message({
                                  message: res.msg,
                                  type: 'success'
                              });
                              this.selectPageAll()
                              this.newDialog = false
                              this.closeDialog()
                          }else{
                              this.closeDialog()
                              this.$message.error(res.msg);
                          }
                      })

                  })
              }else{
                  this.$msg.msge("请完善基本信息后提交");
                  return;
              }
          });



      },

      //提交线索跟踪
      commitCluetrack(){
        if (!this.BscClueTrack.trackDate){
          this.$message({
            type: "error",
            message: '跟踪日期不能为空！'
          });
          return false;
        }
        if (!this.BscClueTrack.trackContent){
          this.$message({
            type: "error",
            message: '跟踪内容不能为空！'
          });
          return false;
        }
        if (!this.BscClueTrack.euType){
          this.$message({
            type: "error",
            message: '客户类型不能为空！'
          });
          return false;
        }
        ss.BscClueManage.insertcluetrack(this.BscClueTrack).then(res => {
          console.log(res)
          if(res.f == true ){
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.selectPageAll()
            //this.newDialog = false
            this.closeCluetrack()
          }else{
            this.closeCluetrack()
            this.$message.error(res.msg);
          }
        })
      },
        mounted() {
          this.selectPageAll();
        },
      //关闭表单
      designateDia(){
            this.designateDialog = false
            this.add.areaCode='',
            this.add.province='',
            this.add.city='',
            this.add.salesManName='',
            this.add.ids = []
            this.salesmanList = null;
            this.cityList = null;
      },
      //关闭提交线索跟踪
      closeCluetrack(){
          this.cluetrackDialog = false,
          this.BscClueTrack.mainId = '',
          this.BscClueTrack.trackDate = '',
          this.BscClueTrack.trackStatus= '',   //线索状态
          this.BscClueTrack.memo = '',
          this.BscClueTrack.trackContent = '',
          this.BscClueTrack.euType = '',
          this.BscClueTrack.legalPerson = '',
          this.BscClueTrack.email = '',
          this.BscClueTrack.user = '',
          this.BscClueTrack.signingType = '',
          this.loudid= '',                   // 漏斗 编号
          this.cluetracktable = null
        this.$refs.BscClueTrack.resetFields()
      },
      //关闭线索跟踪详情
      closeCluedetails(){
            this.cluedetailsDialog = false,
            this.BscClueTrack.mainId = '',
            this.cluetracktable = [];
      },
      //关闭提交催办
      closeCluePress(){
        this.cluepressDialog = false,
        this.BscCluePress.mainId = '',
        this.BscCluePress.pressDate = '',
        this.BscCluePress.pressContent = '',
        this.loudid= '',                   // 漏斗 编号
        this.cluepresstable = null
      },
      //关闭批量催办
      closeCluebatchPress(){
        this.batchpressDialog = false,
        this.BscCluePress.ids = [],
        this.BscCluePress.pressDate = '',
        this.BscCluePress.pressContent = '',
        this.loudid= ''                   // 漏斗 编号
      },
      //信息漏斗表单关闭
      closeloudmainDialog() {
        this.loudmainDialog = false;
        this.cleanAdd();
      },

      closeDialog(){

        this.newDialog = false
        this.editDialog = false
        this.writeNissin = false
        // this.xxx = '';//清空数据
            this.add.id='',
            this.add.areaCode='',
            this.add.province='',
            this.add.city='',
            this.add.salesManName='',
            this.add.channelCode='',
            this.add.clueFrom='',
            this.add.userUnitName='',
            this.add.dept='',
            this.add.leader='',
            this.add.telephone='',
            this.add.proCategory='',
            this.add.incomingCall = null,
            this.add.userRequire = null
            this.add.funnelCode='',
            this.add.memo='',
            this.add.chainGroup='',
            this.add.chainCode='',
            this.add.trackStatus='',
            this.add.ids = [],
            this.salesmanList = null;
            this.cityList = null;
            this.add.targetContent='',
            this.add.customerName='',
            this.add.projectName=''
            this.add.trackStatus= '',
            this.add.emergency= ''
      },
      //关闭弹窗,清空数据
      closeDialogUser() {
        this.newDialogUser = false
        this.institutionalX = false
        //清空数据
        this.addUser.deptName = '';
        this.addUser.deptType = '';
        this.addUser.phone = '';
        this.addUser.leader = '';
        this.addUser.email = '';
        this.addUser.province = '';
        this.addUser.provinceId = '';
        this.addUser.city = '';
        this.addUser.cityId = '';
        this.addUser.area = '';
        this.addUser.areaId = '';
        this.addUser.landmark ='';
        this.addUser.address = '';
        this.addUser.parentCode = '';
        this.addUser.deptSourceChannel = '';
        this.stVal = null;
        this.addUser.schoolTypeName = '';
      },

      //线索导入回调函数
      LoudParts(flag,obj,ddlx){
        this.clueimport = false;
        this.handleFilter();
      },
      //渠道改变
      changeChannel(value){
        console.log("value",value)
        ss.nxAddress.getAddressTypeByChannel(value.code).then(rd =>{
          this.addressTypeList = rd.msg;
          this.addUser.schoolTypeName = '';
        })
      },
      changeSchoolType(value){
        this.addUser.schoolTypeName = value;
      },
      // 通过销售人员名称去查询
      showInfo(event) {
        for (var i = 0; i < this.allsaleman.length; i++) {
          var ishave = false;
          for (var j = 0; j < this.salesmanList.length; j++) {
            /****
             * 1、判断this.salesmanList[j] 是否为空
             * 2、判断下拉集合数据的销售人员名称和总集合销售人员名称是否一致
             * 3、判断下拉集合数据的销售人员名称和页面输入名称是否一致
             *
             **/
            if (this.salesmanList[j]
              && this.salesmanList[j].userName == this.allsaleman[i].userName
              && this.salesmanList[j].userName == event.target.value) {
              //去判断下拉集合数据的销售人员工号是否已经存在
              if (this.salesmanList[j].userCode == this.allsaleman[i].userCode) {
                ishave = true;
                break;
              }
            }
          }
          if (!ishave && event.target.value == this.allsaleman[i].userName) {
            this.salesmanList.push(this.allsaleman[i]);
          }
        }
      },
      loadClueResource(){
        ss.BscClueManage.getClueResource().then(rd =>{
          if(rd.f){
            this.cluesList = rd.msg;
          }
        })
      },
      changeEuType(val){
        console.log(val);
        //如果是经销商就展示
        if(val == 2){
          this.euTypeFlag = true;
        }else {
          this.euTypeFlag = false;
        }
      },
      changeDeptName(val){
        console.log("changeDeptName",val)
        //匹配省市区信息
        ss.nxAddress.getAddressByWl(val).then(rd=>{
          if(rd.f == true){
            this.add.provinceId = rd.msg.provinceId;
            this.add.province = rd.msg.province;
            this.add.cityId = rd.msg.cityId;
            this.add.city = rd.msg.city;
            this.add.areaId = rd.msg.areaId;
            this.add.area = rd.msg.area;
            this.add.address = rd.msg.address;
            this.handleItemChangeN(this.add.provinceId);
          }
        })
        //根据单位名称获取关键字
        ss.nxAddressKeywords.matchKeywords(val).then(rd=>{
          if(rd.msg != null){
            this.add.deptSourceChannel = rd.msg.channelCode;
            this.add.schoolTypeName = rd.msg.userUnit;
            this.matchChannel(rd.msg.channelCode)
          }
        })
      },
      matchChannel(value){
        console.log("value",value)
        ss.nxAddress.getAddressTypeByChannel(value).then(rd =>{
          this.addressTypeList = rd.msg;
          // this.add.schoolTypeName = '';
        })
      },
      //地址选择器-新
      handleItemChangeN(o){
        this.address = _.find(this.shenglist,{code:this.add.provinceId});
        // this.add.province = this.address.name;
        ss.Dictservice.areaTreelist({code:o}).then(rd => {
          this.arealist2 = rd.zlist;
          this.arealist3 = [];
          this.address = _.find(this.arealist2,{code:this.add.cityId});
          // this.add.city = this.address.name;
          this.arealist3 = _.find(this.arealist2,{code:o}).zlist
        })
      },

        isUrl(str) {
            const pattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w\-.#?%~&=@;]*)*$/;
            return pattern.test(str);
        }

    },
    watch:{
        'add.customerName': {
            deep: true,
            handler: function (newVal,oldVal){
            this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
            var len = this.groupList.length;//groupList
            var arr = [];
            for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
                arr.push({
                    value:this.groupList[i].name,
                    id:this.groupList[i].id
                })
                }
            }
            this.groupArr = arr
            }
        },
    },
    created(){
        //是否管理员权限
        this.adminFlag = this.$store.getters.hasRole('swyl_admin');
        //是否省区经理权限
        this.daqujlFlag = this.$store.getters.hasRole('swyl_daqujl');
        //是否线索渠道负责人
        this.xiansuouser = this.$store.getters.hasRole('swyl_xiansuo_user');

        this.usercode = this._user.usercode;
        this.getQuyu();
        this.handleFilter();
        this.getParentInfo();
        this.getProject();
        this.loadClueResource();
    },

}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:110px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    /*/deep/ .h-elformWrap-1 .el-form-item__content{*/
    /*    width: 78%;*/
    /*}*/
    /deep/ .h-elformWrap-1 .el-form-item__content{
      width: 78%;
    }

    .addPro {
      width: 100%;
      /* display:flex; */
    }

    .addPro .el-form-item {
      width: 45% !important;
    }

    .addPro .el-form-item /deep/ .el-form-item__content {
      width: 115px;
    }
    /*设置父级样式*/
    .vue-treeselect >>> .vue-treeselect__control {
      width: 150px;
    }
    .el-switch{
      margin: auto auto auto 20px;
    }

    .custom-label-color .el-form-item__label {
        color:red !important;
    }

    .el-form-item[prop='memo'] .el-form-item__label {
        color: red  !important;
    }
    /*.projectCon p{*/
    /*  justify-content: space-between;*/
    /*  align-items:center;*/
    /*  font-size: 14px;*/
    /*  border-bottom:#1b78e6 1px dashed;*/
    /*  padding: 5px 0;*/
    /*  margin: 0 auto 10px auto;*/
    /*  color: #1b78e6;*/
    /*}*/
</style>
